import styled from "@emotion/styled";

const Hr = styled.hr(({ theme }) => ({
  backgroundColor: theme.colors.black,
  border: 0,
  borderRadius: theme.borderRadius.round,
  height: 2,
  margin: "2rem 0",
}));

export { Hr };
